// removed by extract-text-webpack-plugin
module.exports = {"container":"WaitingRoomFooter__container___13A3o","wand-icon":"WaitingRoomFooter__wand-icon___3zpLp","plus-icon":"WaitingRoomFooter__plus-icon___1APvW"};